import React from "react";
import { Paper, Typography, Stack, Box, Chip } from "@mui/material";

interface DetailsProps {
  data: any;
  title: string;
  overrides?: Record<string, React.ReactNode>;
}

const capitalize = (value: string | number) => {
  if (typeof value !== "string") return value;
  return value.charAt(0).toUpperCase() + value.slice(1);
};

const renderFieldValue = (
  key: string,
  value: any,
  overrides?: Record<string, React.ReactNode>,
): React.ReactNode => {
  if (overrides?.[key]) {
    return overrides[key];
  }

  if (Array.isArray(value)) {
    return (
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          width: "100%",
        }}
      >
        {value.map((item, index) => (
          <Chip
            key={index}
            label={item}
            color="default"
            size="small"
            variant="filled"
          />
        ))}
      </Box>
    );
  }

  return (
    <Typography color="rgba(0, 0, 0, 0.6)">
      {capitalize(value as string | number)}
    </Typography>
  );
};

const Section: React.FC<DetailsProps> = ({ title, data, overrides }) => (
  <Paper sx={{ p: 2 }}>
    <Typography sx={{ mb: 1 }}>{title}</Typography>
    <Stack gap={1}>
      {Object.entries(data).map(([key, value]) => (
        <Paper key={key} sx={{ p: "8px 16px", display: "flex" }}>
          <Box
            sx={{
              width: "30%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography>{key}</Typography>
          </Box>
          <Box
            sx={{
              width: "70%",
              display: "flex",
              alignItems: "center",
            }}
          >
            {renderFieldValue(key, value, overrides)}
          </Box>
        </Paper>
      ))}
    </Stack>
  </Paper>
);
export default Section;
